(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-creator-kit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-ck-chat]');
  if (!button) return;
  const chat = document.querySelector('shopify-chat');
  if (chat) {
    await Promise.race([customElements.whenDefined('shopify-chat'), new Promise(resolve => setTimeout(resolve, 2500))]);
    if (typeof chat.show === 'function') { chat.show(); return; }
  }
  const help = button.closest('.ck-actions')?.querySelector('[data-ck-chat-help]');
  if (help) { help.hidden = false; help.setAttribute('role','status'); }
});

document.querySelectorAll('[data-ck-films]').forEach(carousel=>{
  const rail=carousel.querySelector('[data-ck-film-rail]'),slides=[...rail.children],prev=carousel.querySelector('[data-ck-film-prev]'),next=carousel.querySelector('[data-ck-film-next]'),count=carousel.querySelector('[data-ck-film-count]');
  let active=0;
  const update=()=>{
    const index=Math.max(0,Math.min(slides.length-1,Math.round(rail.scrollLeft/(rail.clientWidth||1))));
    if(index!==active){slides[active].querySelector('iframe').contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), 'https://www.youtube-nocookie.com');active=index;}
    count.textContent=(active+1)+' / '+slides.length;prev.disabled=active===0;next.disabled=active===slides.length-1;
  };
  const move=step=>rail.scrollTo({left:Math.max(0,Math.min(slides.length-1,active+step))*rail.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
  rail.addEventListener('scroll',update,{passive:true});
  rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  new ResizeObserver(()=>{rail.scrollTo({left:active*rail.clientWidth,behavior:'instant'});update();}).observe(rail);
  update();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-parka-test"]) return;
  try {
    
document.querySelectorAll('[data-quantity-step]').forEach(button=>{
  button.addEventListener('click',()=>{
    const input=button.closest('.pk-order-quantity').querySelector('input');
    input.value=String(Math.max(1,(parseInt(input.value,10)||1)+Number(button.dataset.quantityStep)));
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });
});

if (window.location.hash === '#cc-chat') {
  let attempts = 0;
  const openParkaChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (chat && typeof chat.show === 'function') {
      chat.show();
      return;
    }
    if (++attempts < 40) window.setTimeout(openParkaChat, 250);
  };
  openParkaChat();
}

  } catch(e) { console.error(e); }
})();
})();
